// Global Booking Config Actions
export const BOOKING_CONFIG_REQUESTED = 'bookings/config/BOOKING_CONFIG_REQUESTED';
export const BOOKING_CONFIG_LOADED = 'bookings/config/BOOKING_CONFIG_LOADED';
export const BOOKING_CONFIG_LOADED_FOR_FORM = 'bookings/config/BOOKING_CONFIG_LOADED_FOR_FORM';
export const BOOKING_CONFIG_LOADED_FOR_AMENITY_SUMMARY = 'bookings/config/BOOKING_CONFIG_LOADED_FOR_AMENITY_SUMMARY';

// Booking form actions

export const BOOKING_UPDATED = 'bookings/form/BOOKING_UPDATED';

export const BOOKING_CONFIRMED = 'bookings/BOOKING_CONFIRMED';


export const bookingConfigRequested = () => ({
    type: BOOKING_CONFIG_REQUESTED,
})

export const bookingConfigLoaded = () => ({
    type: BOOKING_CONFIG_LOADED,
})

export const bookingConfigLoadedForForm = (amenity, category, bookingConfig) => ({
    type: BOOKING_CONFIG_LOADED_FOR_FORM,
    payload: {
        amenity: amenity,
        category: category,
        bookingConfig: bookingConfig
    }
})

export const bookingConfigLoadedForAmenitySummary = (amenity, category, bookingConfig) => ({
    type: BOOKING_CONFIG_LOADED_FOR_AMENITY_SUMMARY,
    payload: {
        amenity: amenity,
        category: category,
        bookingConfig: bookingConfig,
    }
});


export const bookingUpdated = (booking) => ({
    type: BOOKING_UPDATED,
    payload: booking
})

export const bookingConfirmed = (booking) => ({
    type: BOOKING_CONFIRMED,
    payload: {
        booking: booking
    }
})
